import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import { showErrorMessages } from "helpers/helpers"

import { GET_ALL_RISK_MANAGEMENT_SETTING } from "./actionTypes"
import { changePreloader } from "../../store/layout/actions"
import { getAllRiskManagementSetting, getCashoutPercentage } from "../../helpers/repository"
import { getAllRiskManagementSettingResponseSuccess } from "./actions"
import { showMessage } from "components/Common/Toaster"
import { apiError } from "store/actions"

function* attemptGetAllProductCategories() {
  try {
    yield put(changePreloader(true))
    const response = yield call(getAllRiskManagementSetting)
    // const cashoutResponse = yield call(getCashoutPercentage)
    yield put(getAllRiskManagementSettingResponseSuccess(response.data.data))
    yield put(changePreloader(false))
  } catch (error) {
    showErrorMessages(error)
  }
}

function* riskManagementSaga() {
  yield takeEvery(
    GET_ALL_RISK_MANAGEMENT_SETTING,
    attemptGetAllProductCategories
  )
}

export default riskManagementSaga
